import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as Freeze } from 'assets/svgs/freeze.svg';
import { Button } from 'components/atoms/button';
import { IconWrapper } from 'components/atoms/icon-shell/icon-shell';
import { PermissionRuleName } from 'constant';
import { useUser } from 'hooks/use-user';

interface Props {
  onClick: () => void;
}
export const FreezeDocumentBtn: FC<Props> = ({ onClick }) => {
  const { user } = useUser();

  return (
    <Tooltip
      title={
        <FormattedMessage
          id="document.freeze"
          values={{ companyName: user.company.companyName || '' }}
        />
      }
      placement="bottom"
    >
      <Button
        type="text"
        icon={
          <IconWrapper>
            <Freeze />
          </IconWrapper>
        }
        size="small"
        onClick={onClick}
        ruleName={PermissionRuleName.SpaceDocumentFreezeAction}
      />
    </Tooltip>
  );
};
